module.exports = __webpack_public_path__ + "img/11.3bdc71e.png";